import { render } from "./modalDefault.vue?vue&type=template&id=0b731176&scoped=true"
import script from "./modalDefault.vue?vue&type=script&lang=js"
export * from "./modalDefault.vue?vue&type=script&lang=js"

import "./modalDefault.vue?vue&type=style&index=0&id=0b731176&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b731176"

export default script